import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { formatDate, DATE_FORMATS } from '@wix/da-i18next/pkg/time/functions';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ClockIcon from '@wix/da-ds/pkg/Icons/24x24/Clock';
import PlaceholderBlock from '@wix/da-shared-react/pkg/PlaceholderBlock';

import s from './DeviationPublishedTime.scss';

interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const DeviationPublishedTime: FC<Props> = ({ deviation, className }) => {
  const { t, i18n } = useTranslation();
  const [isMounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!deviation.publishedTime) {
    return null;
  }

  const scheduledTime = !deviation.isPublished && deviation.scheduledPublishTime;
  if (scheduledTime) {
    return (
      <div className={cn(s['root'], s['scheduled'], className)}>
        <ClockIcon size={IconSize.SMALLER} disableDefaultColors className={s['scheduled-icon']} />
        {isMounted ? (
          formatDate(scheduledTime, DATE_FORMATS.DateTime.ShortWithoutYear, i18n.language)
        ) : (
          <PlaceholderBlock width={150} height={12} />
        )}
      </div>
    );
  }

  return (
    <div className={cn(s['root'], className)} title={t('studio.table.status.published')}>
      {formatDate(deviation.publishedTime, DATE_FORMATS.Date.Short, i18n.language)}
    </div>
  );
};
DeviationPublishedTime.displayName = 'DeviationPublishedTime';

export default DeviationPublishedTime;
